// single pages
import homePage from '../pages/Home.vue'
import dashboard from '../pages/Dashboard.vue'
import orgedit from '../pages/Organization/Edit.vue'
import orgpools from '../pages/Organization/Pools.vue'
import orgprivs from '../pages/Organization/Privileges.vue'
import orgorderhistory from '../pages/Organization/OrderHistory.vue'
import orgreporting from '../pages/Organization/Reporting.vue'
import orgtransfer from '../pages/Organization/Transfer.vue'
import groupdash from '../pages/Group/Dashboard.vue'
import groupaddinvite from '../pages/Group/AddInvite.vue'
import groupmembers from '../pages/Group/Members.vue'
import groupgroups from '../pages/Group/Subgroups.vue'
import groupreporting from '../pages/Group/Reporting.vue'
import groupprivileges from '../pages/Group/Privileges.vue'
import grouptags from '../pages/Group/Tags.vue'
import groupedit from '../pages/Group/Edit.vue'
import grouplogs from '../pages/Group/Logs.vue'
import groupassign from '../pages/Group/Assign.vue'
import pooldash from '../pages/Pool/Dashboard.vue'
import pooladdinvite from '../pages/Pool/AddInvite.vue'
import poolmembers from '../pages/Pool/Members.vue'
import poolgroups from '../pages/Pool/Groups.vue'
import poolproducts from '../pages/Pool/Products.vue'
import poolbundles from '../pages/Pool/Bundles.vue'
import poolcurricula from '../pages/Pool/TrainingPlans.vue'
import poolprivileges from '../pages/Pool/Privileges.vue'
import poolreporting from '../pages/Pool/Reporting.vue'
import poolassign from '../pages/Pool/Assign.vue'
import pooltags from '../pages/Pool/Tags.vue'
import pooledit from '../pages/Pool/Edit.vue'
import poollogs from '../pages/Pool/Logs.vue'
import cliedit from "../pages/Client/Edit.vue"
import climyaccount from '../pages/Client/MyAccount.vue'
import cliinbox from '../pages/Client/Inbox.vue'
import clitutorials from '../pages/Client/Tutorials.vue'
import clinotifications from '../pages/Client/Notifications.vue'
import clitrainingplans from '../pages/Client/TrainingPlans.vue'
import clicertificates from '../pages/Client/Certificates.vue'
import clireports from '../pages/Client/Reports.vue'
import cliaddcertificate from '../pages/Client/AddCertificate.vue'
import edittrainingplans from '../pages/TrainingPlans/Edit.vue'
import editlessons from '../pages/TrainingPlans/EditLesson.vue'
import bundleusers from '../pages/Bundle/BundleUsers.vue'
import bundleschedules from '../pages/Bundle/BundleSchedules.vue'
import message from '../pages/Client/Message.vue'
import newmessage from '../pages/Client/NewMessage.vue'
import notFoundPage from '../pages/NotFound.vue'

export const routes = [
  {
    path: '/',
    name: 'index',
    component: homePage,
    meta: { title: 'Admin Center' }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
    meta: { title: 'Dashboard'}
  },
  {
    path: '/organization/:id/edit',
    name: 'orgedit',
    component: orgedit,
    meta: { title: 'Organization Edit'}
  },
  {
     path: '/organization/:id/pools',
     name: 'orgpools',
     component: orgpools,
     meta: { title: 'Organization Pools'}
  },
   {
      path: '/organization/:id/privileges',
      name: 'orgprivs',
      component: orgprivs,
      meta: { title: 'Organization Privileges'}
   },
   {
     path: '/organization/:id/transfer',
     name: 'orgtransfer',
     component: orgtransfer,
     meta: { title: 'Transfer Licenses'}
   },
   {
     path: '/organization/:id/orderhistory',
     name: 'orgorderhistory',
     component: orgorderhistory,
     meta: { title: 'Organization Order History'}
   },
  {
    path: '/organization/:id/reporting',
    name: 'orgreporting',
    component: orgreporting,
    meta: { title: 'Organization Reporting'}
  },
    {
      path: '/group/:id/dashboard',
      name: 'groupdash',
      component: groupdash,
      meta: {title: 'Group Dashboard'}
    },
  {
    path: '/group/:id/logs',
    name: 'grouplogs',
    component: grouplogs,
    meta: {title: 'Group Logs'}
  },
  {
    path: '/group/:id/edit',
    name: 'groupedit',
    component: groupedit,
    meta: {title: 'Group Edit'}
  },
  {
    path: '/group/:id/tags',
    name: 'grouptags',
    component: grouptags,
    meta: {title: 'Group Tags'}
  },
  {
     path: '/group/:id/subgroups',
     name: 'groupgroups',
     component: groupgroups,
     meta: {title: 'Group Subgroups'}
  },
   {
     path: '/group/:id/members',
     name: 'groupmembers',
     component: groupmembers,
     meta: {title: 'Group Members'}
   },
  {
    path: '/group/:id/reporting',
    name: 'groupreporting',
    component: groupreporting,
    meta: {title: 'Group Reporting'}
  },
  {
    path: '/group/:id/privileges',
    name: 'groupprivileges',
    component: groupprivileges,
    meta: {title: 'Group Privileges'}
  },
  {
    path: '/group/:id/assign/:type/do',
    name: 'groupassign',
    component: groupassign,
    meta: { title: 'License Pool Group Assign'}
  },
  {
    path: '/group/:id/addinvite',
    name: 'groupaddinvite',
    component: groupaddinvite,
    meta: {title: 'Group Add/Invite'}
  },
  {
    path: '/pool/:id/addinvite',
    name: 'pooladdinvite',
    component: pooladdinvite,
    meta: {title: 'Pool Add/Invite'}
  },
  {
     path: '/pool/:id/dashboard',
     name: 'pooldash',
     component: pooldash,
     meta: { title: 'License Pool Dashboard'}
  },
  {
    path: '/pool/:id/members',
    name: 'poolmembers',
    component: poolmembers,
    meta: { title: 'License Pool Members'}
  },
  {
     path: '/pool/:id/groups',
     name: 'poolgroups',
     component: poolgroups,
     meta: { title: 'License Pool Groups'}
  },
   {
     path: '/pool/:id/products',
     name: 'poolproducts',
     component: poolproducts,
     meta: { title: 'License Pool Products'}
   },
  {
     path: '/pool/:id/bundles',
     name: 'poolbundles',
     component: poolbundles,
     meta: { title: 'License Pool Bundles'}
  },
  {
    path: '/pool/:id/pooltrainingplans',
    name: 'poolcurricula',
    component: poolcurricula,
    meta: { title: 'License Pool Training Plans'}
  },
  {
    path: '/pool/:id/privileges',
    name: 'poolprivileges',
    component: poolprivileges,
    meta: { title: 'License Pool Privileges'}
  },
  {
    path: '/pool/:id/reporting',
    name: 'poolreporting',
    component: poolreporting,
    meta: { title: 'License Pool Reporting'}
  },
  {
     path: '/pool/:id/tags',
     name: 'pooltags',
     component: pooltags,
     meta: { title: 'License Pool Tags'}
  },
  {
     path: '/pool/:id/assign/:type/do',
     name: 'poolassign',
     component: poolassign,
     meta: { title: 'License Pool Assign'}
  },
  {
    path: '/pool/:id/edit',
    name: 'pooledit',
    component: pooledit,
    meta: { title: 'License Pool Edit'}
  },
  {
    path: '/pool/:id/logs',
    name: 'poollogs',
    component: poollogs,
    meta: { title: 'License Pool Logs'}
  },
  {
    path: '/client/:id',
    name: 'cliedit',
    component: cliedit,
    meta: {title: "Edit Client"}
  },
  {
    path: '/client/:id/myaccount',
    name: 'climyaccount',
    component: climyaccount,
    meta: { title: 'My Account'}
  },
  {
    path: '/client/:id/inbox',
    name: 'cliinbox',
    component: cliinbox,
    meta: { title: 'Inbox'}
  },
  {
    path: '/client/:id/reports',
    name: 'clireports',
    component: clireports,
    meta: {title: 'Reports'}
  },
  {
    path: '/client/:id/tutorials',
    name: 'clitutorials',
    component: clitutorials,
    meta: { title: 'Tutorials'}
  },
  {
    path: '/client/:id/notifications',
    name: 'clinotifications',
    component: clinotifications,
    meta: { title: 'Notifications'}
  },
  {
     path: '/client/:id/trainingplans',
     name: 'clitrainingplans',
     component: clitrainingplans,
     meta: { title: 'Training Plans'}
  },
  {
     path: '/client/:id/certificates',
     name: 'clicertificates',
     component: clicertificates,
     meta: { title: 'Certificates'}
  },
  {
      path: '/client/:id/certificates/add',
      name: 'cliaddcertificate',
      component: cliaddcertificate,
      meta: { title: 'Add Certificate'}
  },
  {
    path: '/trainingplans/:id/edit',
    name: 'edittrainingplans',
    component: edittrainingplans,
    meta: { title: 'Edit Training Plan'}
  },
  {
    path: '/trainingplans/:tpid/lesson/:lid',
    name: 'editlessons',
    component: editlessons,
    meta: {title: 'Edit Lesson'}
  },
  {
    path: '/bundles/:pid/:id/users',
    name: 'bundleusers',
    component: bundleusers,
    meta: {title: 'Bundle Users'}
  },
  {
    path: '/bundles/:pid/:bid/schedules',
    name: 'bundleschedules',
    component: bundleschedules,
    meta: {title: 'Bundle Schedules'}
  },
  {
    path: '/client/message/:id',
    name: 'message',
    component: message,
    meta: {title: 'Message'}
  },
  {
    path: '/client/newmessage/:replyid',
    name: 'newmessage',
    component: newmessage,
    meta: {title: 'New Message'}
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: 'Page Not Found' }
  }
]
